import { SkeletonItem } from '@capsicum/common-web';
import { useMemo } from 'react';

import { NCWalletTokenListCardSkeleton } from '../nc-wallet-token-list-card/NCWalletTokenListCardSkeleton';

import { TokenCards, Wrapper } from './NCWalletTokenCards.styled';

export const NCWalletTokenCardsSkeleton = () => {
	const tokenSkeletons = useMemo(
		() =>
			Array(3)
				.fill(null)
				.map((_, index) => <NCWalletTokenListCardSkeleton key={index} />),
		[]
	);

	return (
		<Wrapper>
			<SkeletonItem height={20} width={128} />

			<TokenCards>{tokenSkeletons}</TokenCards>
		</Wrapper>
	);
};
